import React, { useEffect, useState } from "react";
import { FC } from "react";

export interface SymboleMonnaieProps {
  symbole: string;
  className?: string;
  className3c?: string;
  classText?: string;
  classText3c?: string;
}

const SymboleMonnaie: FC<SymboleMonnaieProps> = ({
 symbole,
 className="w-5 h-5",
  className3c="w-5 h-5",
 classText="text-monnaie1c",
classText3c="text-monnaie3c"
}) => {
  return symbole && symbole.length === 3  ? (
   <span className={`${className3c} no-slider-margin text-xs text-amber-500 ml-2 flex items-center justify-center border border-amber-500 rounded-full`}>
  <span className={`${classText3c} no-slider-margin`}>{symbole}</span>
  </span>)
  : (
   <span className={`${className} no-slider-margin text-xs text-amber-500 ml-2 flex items-center justify-center border border-amber-500 rounded-full`}>
   <span className={`${classText} no-slider-margin`}>{symbole}</span>
  </span>)
}
;

export default SymboleMonnaie;
